import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import CardBeneficios from "../components/CardBeneficios";
import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import useStore from "../store/useStore";
import VideoComex from "../components/VideoComex";

import Seo from "../components/Seo";
import ProductosOne from "../components/ProductosOne";
import SkeletonLoader from "../components/SkeletonLoader";

// Lista estática de beneficios
const productos = [
  {
    title: "100% Compliance",
    description:
      "Prevención de riesgos legales al mantener actualizado a la normativa todo el proceso de importación/exportación.",
  },
  {
    title: "Reducción de costos",
    description:
      "Minimización de errores al automatizar cargas documentales y setear procedimientos automatizados.",
  },
  {
    title: "Velocidad",
    description:
      "Tecnología robusta para soportar el procesamiento de grandes volúmenes de datos.",
  },
];

export default function Mre() {
  // Extrae funciones y datos desde el store (Zustand)
  const {
    mreHeroes,
    getMreHeroes,
    seoMres,
    fetchSeoMres,
    mreCards,
    getMreCards,
    mreVideos, // Lista de videos para MRE
    getMreVideos, // Acción para obtener videos
  } = useStore();

  const urlApi = process.env.REACT_APP_STRAPI_URL;

  // Al montar, obtenemos héroes, tarjetas y videos
  useEffect(() => {
    getMreHeroes();
    getMreCards();
    getMreVideos();
  }, [getMreHeroes, getMreCards, getMreVideos]);

  // Carga la información de SEO
  useEffect(() => {
    fetchSeoMres();
  }, [fetchSeoMres]);

  return (
    <>
      {/* Metaetiquetas SEO dinámicas */}
      <Seo
        metaTitle={seoMres[0]?.metatitle}
        metaDescription={seoMres[0]?.metadescription}
        metaImage={seoMres[0]?.metaimage?.url}
        metaKeywords={seoMres[0]?.metakeywords}
        canonicalURL={seoMres[0]?.canonicalurl}
      />

      {/* Encabezado con navbar */}
      <header>
        <Navbar tabIndex={0} aria-label="Navegación principal" />
      </header>

      {/* Contenido principal */}
      <main className="bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
        {/* Hero dinámico o placeholder */}
        <section aria-label="Hero MRE">
          {mreHeroes?.length === 0 || !mreHeroes ? (
            <VideoBackground
              video="/placeholder.mp4"
              titulo1="Cargando..."
              titulo2="Espere un momento"
              textbutton="SOLICITAR DEMO"
              logo="/placeholder-logo.png"
              tabIndex={0}
              aria-label="Video de carga"
            />
          ) : (
            mreHeroes.map((item, index) => (
              <VideoBackground
                key={index}
                video={`${urlApi}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="SOLICITAR DEMO"
                link="/contact"
                logo={`${urlApi}${
                  item.img[0]?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
                tabIndex={0}
                aria-label={`Video de ${item.titulo}`}
              />
            ))
          )}
        </section>

        {/* Video específico del producto MRE */}
        <section className="" aria-label="Video específico del producto MRE">
          {mreVideos && mreVideos[0]?.video?.url ? (
            <VideoComex
              key={mreVideos[0]?.id}
              video={mreVideos[0]?.video.url}
              controls={mreVideos[0]?.control}
              autoPlay={mreVideos[0]?.autoplay}
              muted={mreVideos[0]?.muted}
              loop={mreVideos[0]?.loop}
              tabIndex={0}
              aria-label="Video demostrativo de MRE"
            />
          ) : (
            <SkeletonLoader
              text="Cargando video..."
              tabIndex={0}
              aria-label="Cargando video del producto MRE"
            />
          )}
        </section>

        {/* Beneficios principales del producto */}
        <section
          className="mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0"
          tabIndex={0}
          aria-label="Beneficios principales del producto MRE"
        >
          <div className="flex container flex-col h-full">
            <h1
              className="text-sidom-orange mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[60px] text-3xl md:text-[40px] lg:text-[45px] leading-tight font-extrabold text-left"
              tabIndex={0}
              aria-label="Título: Beneficios"
            >
              Beneficios
            </h1>

            {/* Tarjetas individuales por beneficio */}
            <div>
              {productos.map((producto, index) => (
                <CardBeneficios
                  key={index}
                  titulo={producto.title}
                  descripcion={producto.description}
                  tabIndex={0}
                  aria-label={`Beneficio: ${producto.title}`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Sección con los productos dinámicos obtenidos desde Strapi */}
        <section aria-label="Productos dinámicos obtenidos desde Strapi">
          <section
            className="mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0"
            tabIndex={0}
            aria-label="Sección de productos dinámicos"
          >
            <div className="container">
              <ProductosOne
                productos={mreCards}
                tabIndex={0}
                aria-label="Lista de productos dinámicos"
              />
            </div>
          </section>
        </section>
      </main>

      {/* Footer */}
      <footer>
        <Footer tabIndex={0} aria-label="Pie de página" />
      </footer>

      {/* Botón de tema (Switcher) */}
      <Switcher tabIndex={0} aria-label="Botón para cambiar tema" />
    </>
  );
}
